import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CustomerDocumentType } from './customer-document-type.interface';
import { CustomerDocumentTypeService } from './customer-document-type.service';

const service = new CustomerDocumentTypeService();

export interface CustomerDocumentTypeState {
   customerDocumentTypes: CustomerDocumentType[];
}

const CustomerDocumentTypeStore: Module<CustomerDocumentTypeState, StoreState> = {
   namespaced: true,
   state: {
      customerDocumentTypes: [],
   },
   getters: {},
   mutations: {
      SET_CUSTOMER_DOCUMENT_TYPES(state, customerDocumentTypes: CustomerDocumentType[]) {
         state.customerDocumentTypes = customerDocumentTypes;
      },
   },
   actions: {
      async getCustomerDocumentTypes(ctx, params?: LocationQuery) {
         const response = await service.getCustomerDocumentTypes(params);
         ctx.commit('SET_CUSTOMER_DOCUMENT_TYPES', response.data);
         return response;
      },
   },
};

export default CustomerDocumentTypeStore;
